// material-ui
import { alpha, Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - AUTOCOMPLETE ||============================== //

export default function Autocomplete(theme: Theme) {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            padding: '3px 9px',
            transition: theme.transitions.create(['box-shadow', 'border-color', 'background-color'], {
              duration: theme.transitions.duration.shorter
            })
          }
        },
        paper: {
          borderRadius: 10,
          marginTop: 6,
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: `0 12px 32px ${alpha(theme.palette.common.black, theme.palette.mode === 'dark' ? 0.35 : 0.08)}`
        },
        popupIndicator: {
          width: 'auto',
          height: 'auto',
          borderRadius: 1,
          transition: 'background-color 0.15s ease',
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            color: theme.palette.primary.main
          }
        },
        clearIndicator: {
          width: 'auto',
          height: 'auto',
          borderRadius: 1,
          transition: 'background-color 0.15s ease',
          '&:hover': {
            backgroundColor: alpha(theme.palette.error.main, 0.08),
            color: theme.palette.error.main
          }
        }
      }
    }
  };
}
